export const swiperOption: any = {
    176: {
        slidesPerView: 1
    },
    768: {
        slidesPerView: 2,
    },
    1000: {
        slidesPerView: 4,
    },
}

export const secondOption: any = {
    176: {
        slidesPerView: 1,
    },
    768: {
        slidesPerView: 2,
    },
    1000: {
        slidesPerView: 2.5,
    },
}

export const commentOption: any = {
    176: {
        slidesPerView: 1.3,
    },
    768: {
        slidesPerView: 2.5,
    },
    1000: {
        slidesPerView: 4,
    },
}